import { Grid } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Layout from "../../../components/Layout";
import Snack from "../../../components/Snack";

import {
  ActionCreators as UtilisateursActionsCreators,
  Selectors as UtilisateursSelectors,
} from "../../../redux/Utilisateurs";
import { Profil, Utilisateur } from "../../../services/Api/swagger";
import UtilisateurBesseForm, {
  UtilisateurBesseFormData,
} from "../UtilisateurBesseForm";
import { useModifierUtilisateurBesse } from "./selectors";
import { transformUtilisateurBesseDataToModel } from "../helpers";
import { useNavigate } from "react-router";

interface Props {
  utilisateur?: Utilisateur;
  modifierUtilisateur(params: any): void;
  utilisateurConnecte?: Utilisateur;
  getProfilsBesse(params: string): void;
  profilsBesse?: Profil[];
  fetching: boolean;
  utilisateurError?: any;
  emptyErrorMessages(): void;
}

function ModifierUtilisateurBesse() {
  const {
    profilsBesse,
    modifierUtilisateur,
    utilisateurFetching,
    utilisateurError,
    resetPutUtilisateur,
    utilisateurConnecte,
    utilisateur,
    initialValues,
  } = useModifierUtilisateurBesse();
  const handleSubmit = (values: Utilisateur | UtilisateurBesseFormData) => {
    // const transformedValues = transformUtilisateurBesseDataToModel(values);
    const params = {
      ...{ username: (values as Utilisateur).identifiant || "" },
      ...{ body: values as Utilisateur },
    };
    modifierUtilisateur(params);
  };

  const navigate = useNavigate();
  const handlePrecedent = () => {
    navigate("/mes-utilisateurs");
  };

  const handleClose = () => {
    resetPutUtilisateur();
  };
  const renderError = (error: any) => {
    return (
      <Snack
        onClose={handleClose}
        open={true}
        variant="error"
        message={error.message}
      />
    );
  };

  const utilisateurBESSE =
    utilisateurConnecte && utilisateurConnecte.role === "BESSE";

  return (
    <Layout title="Modifier un utilisateur Bessé">
      <div>
        <h2>Modifier un utilisateur Bessé</h2>
        <UtilisateurBesseForm
          profilsBesse={profilsBesse}
          onSubmit={handleSubmit}
          handlePrecedent={handlePrecedent}
          utilisateurBESSE={utilisateurBESSE}
          isFetching={utilisateurFetching}
          initialValues={initialValues}
          isModify={true}
        />
        <Grid container justifyContent="flex-end" style={{ marginTop: "12px" }}>
          {utilisateurError && renderError(utilisateurError)}
        </Grid>
      </div>
    </Layout>
  );
}

export default ModifierUtilisateurBesse;
